import AsyncPage from 'pages/AsyncPage'

/**
 * Users will land at this page after clicking a link in an email,
 * so don't expect any pre-existing state to be available.
 *
 * The link includes a JWT token with 24 hour expiry, so:
 *  -- invoke the API to complete registration
 *     -- success - tell the user it worked and give them a way to move on ...
 *     -- failure - tell them why, give them a way to try again
 *        -- failure modes include:
 *           -- token expired - tell them it expired and give them a way to get a new token sent to their email
 *           -- user-id or email don't exist - tell them what's wrong and give them a way to re-register
 *           -- something unexpected - give user an option to retry?
 */

// todo: pull up to AsyncPage
import universal from 'react-universal-component'
const component = universal(props => import('./EmailTokenConfirmationPage'))

class AsyncEmailTokenConfirmationPage extends AsyncPage {
  constructor() {
    super({
      isChromeless: true,
      pageComponent: component
    })
  }
}

export default new AsyncEmailTokenConfirmationPage()
